(() => {
  if (window.__wonderlensOfferInstalled) return;
  window.__wonderlensOfferInstalled = true;
  const ids = new Set(['67765624504568', '67765624537336']);
  const rule = '1 free 32GB microSD card per bundle; 12 specimens with 2 microscopes, 24 with 3.';
  const gifts = [
    ['1 × 32GB microSD card'],
    ['1 × 32GB microSD card', '1 × 12-piece specimen set'],
    ['1 × 32GB microSD card', '2 × 12-piece specimen sets (24 specimens)']
  ];
  let scheduled = false;
  function render() {
    scheduled = false;
    const bars = [...document.querySelectorAll('.kaching-bundles__bar')];
    if (bars.length !== 3) return;
    bars.forEach((bar, index) => {
      const compare = bar.querySelector('.kaching-bundles__bar-full-price');
      const compareText = ['$99.90', '$199.80', '$299.70'][index];
      if (compare && compare.textContent.trim() !== compareText) compare.textContent = compareText;
      if (bar.querySelector('.wonderlens-gifts')) return;
      const box = document.createElement('div');
      box.className = 'wonderlens-gifts';
      box.innerHTML = '<strong>Included FREE</strong>' + gifts[index].map((text, n) => '<div class="wonderlens-gift"><img width="46" height="46" alt="'+ (n ? 'Prepared specimen slides' : '32GB microSD card') +'" src="'+ (n ? window.wonderlensGiftImages.specimens : window.wonderlensGiftImages.card) +'"><span>'+text+'</span></div>').join('');
      (bar.querySelector('.kaching-bundles__bar-wrapper') || bar).appendChild(box);
    });
    for (const form of document.querySelectorAll('form[action*="/cart/add"]')) {
      const id = form.querySelector('[name="id"]');
      if (!id || !ids.has(String(id.value))) continue;
      for (const [name, value] of Object.entries({'properties[Included gifts]': rule, 'properties[_wonderlens_gift_rule]': 'WONDERLENS-v1'})) {
        let input = form.querySelector('input[name="'+name+'"]');
        if (!input) { input = document.createElement('input'); input.type='hidden'; input.name=name; form.appendChild(input); }
        input.value=value;
      }
    }
    const nativePrice = document.querySelector('.product__info-container .price');
    if (nativePrice) {
      nativePrice.classList.add('wonderlens-price-native');
      if (!document.getElementById('wonderlens-display-price')) {
        const displayPrice = document.createElement('div');
        displayPrice.id = 'wonderlens-display-price';
        displayPrice.className = 'wonderlens-display-price';
        displayPrice.innerHTML = '<strong>$49.95</strong> <s>$99.90</s> <span>50% OFF</span>';
        nativePrice.after(displayPrice);
      }
    }
  }
  function schedule() { if (!scheduled) { scheduled=true; requestAnimationFrame(render); } }
  new MutationObserver(schedule).observe(document.body, {subtree:true,childList:true});
  document.addEventListener('change',schedule,true);
  document.addEventListener('submit',render,true);
  render();
})();
